import type { Address } from "@/models/user";
import type { AuthRole } from "./auth.api.types";

/**
 * Canonical authenticated identity — always sourced from GET /auth/v1/me.
 */
export interface AuthenticatedUser {
  userId: string;
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  restaurantId: string | null;
  roles: AuthRole[];
  tokenVersion: number;
}

/**
 * Client-side enrichment — NOT from /me.
 * Loaded via address APIs and future profile endpoints.
 */
export interface UserEnrichment {
  addresses: Address[];
  mobileNo: string | null;
  dateOfBirth: string | null;
}

/** In-app user view: authoritative identity + optional enrichment. */
export interface AppUser {
  identity: AuthenticatedUser;
  enrichment: UserEnrichment;
}

export const emptyEnrichment = (): UserEnrichment => ({
  addresses: [],
  mobileNo: null,
  dateOfBirth: null,
});
